/**
 * Created by fers on 05.02.16.
 */

import Link from 'react-router/lib/Link';
import {injectIntl, FormattedMessage, defineMessages, IntlShape} from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import * as Tool from '../fw/Tool';
import ScenarioIcon from './ScenarioIcon.react';
import "./Scenario.scss";
import {channelDefState} from '../../common/model-api/ChannelDefType';
import config from '../../common/config';
import { Scenario } from '../../common/types/types';

export const messages = defineMessages({
    boxTitle: {id: 'scenarioBoxWizard.title', 'defaultMessage': 'View integration scenario'},
    deprecated: {id: 'scenarioBoxWizard.deprecated', 'defaultMessage': 'Deprecated'},

});

interface ScenarioBoxProps {
    absoluteUrls?: boolean;
    className?: string;
    float?: boolean;
    forDevelopers?: boolean;
    intl?: object;
    metadata: object;
    onClick?: (...args: unknown[]) => unknown;
    scenario: Scenario;
    style?: object;
    urlMapping?: object;
}

class ScenarioBox extends React.Component<ScenarioBoxProps> {

    static propTypes = {
        absoluteUrls: PropTypes.bool,
        className: PropTypes.string,
		float: PropTypes.bool,
        forDevelopers: PropTypes.bool,
		intl: PropTypes.object,
        metadata: PropTypes.object.isRequired,
        onClick: PropTypes.func,
        scenario: PropTypes.object.isRequired,
		style: PropTypes.object,
        urlMapping: PropTypes.object,
    };

	static defaultProps = {
		float: true
	};

    onClick = (e) => {
        return this.props.onClick(e, this.props.scenario);
    };

    render() {
        const { scenario, urlMapping, metadata } = this.props;

        let title = Tool.getDataForColumn('title', metadata.fields(), scenario);
        if (!title) {
            title = Tool.getDataForColumn('name', metadata.fields(), scenario);
        }

        let state = scenario.state;

        if (channelDefState[scenario.state] && channelDefState[scenario.channelState] && channelDefState[scenario.state]['priority'] > channelDefState[scenario.channelState]['priority']) {
            state = scenario.channelState;
        }

        if (scenario.deprecated) {
            state = this.props.intl.formatMessage(messages.deprecated);
        }

        let url = urlMapping.getUrl(metadata, 'view', scenario);

        let payPlan = scenario.requiredPayPlan;

        if (payPlan === "" || payPlan === "-") {
            payPlan = null;
        }

        let status = null;
        if (this.props.forDevelopers) {
            if (scenario.isInvalid) {
                status = <div className="scenario-invalid"><span className="fa fa-times-circle"></span></div>;
            } else if (scenario.requiresCaching) {
                status = <div className="scenario-invalid"><span className="fa fa-copyright"></span></div>;
            }
        }

        return (
            <div className={"scenarioGridList-box" + (this.props.float ? ' float' : '')} style={this.props.style}>
                <Link className={this.props.className ? this.props.className : ""} href={this.props.absoluteUrls ? config.PUBLIC_APP_URL + url : url} onClick={this.props.onClick ? this.onClick : null} target={this.props.absoluteUrls ? "_blank" : null} title={this.props.intl.formatMessage(messages.boxTitle)} to={this.props.absoluteUrls ? config.PUBLIC_APP_URL + url : url}>
					<div>
                        {status}

						<ScenarioIcon payPlan={payPlan} scenario={scenario} state={state} />
						<h3>{Tool.maxTextLength(title)}</h3>
                        <p>{Tool.maxTextLength(scenario.description, 200)}</p>
                        <div className="more">
                            <span><FormattedMessage defaultMessage="View integration" id="scenarioBoxWizard.viewIntegratio" /><i className="fa fa-chevron-circle-right"></i></span>
                        </div>
					</div>
                </Link>
            </div>
        );
    }
}
export default Relay.createContainer(injectIntl(ScenarioBox), {
    fragments: {
        scenario: () => Relay.QL`
            fragment on Scenario {
                id,
                realId,
                name,
                title,
                description,
                state,
                channelState,
                deprecated,
                isInvalid,
                requiresCaching,
                requiredPayPlan,
                visibility,
                urlFragment,
                scenarioDef {
                    id,
                    name,
                    realId,
                },
                ${ScenarioIcon.getFragment('scenario')}
                scenarios2ChannelDefs(first: 100) {
                    edges {
                        node {
                            id,
                            realId,
                            ruleType,
                            channelDef {
                                id,
                                name,
                                icon,
                                extendedFrom_id,
                                extendedFrom {
                                    id,
                                    realId,
                                    icon
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
});
